(function () {
    'use strict';

    angular
        .module('cacmDataPointModule', []);
})();
